import React from "react";
import PropTypes from "prop-types";
import { Box, Flex, Button, Icon, Popover } from "orcs-design-system";
import parseHTMLToReact from "html-react-parser";

export const UserMessage = ({
  message,
  messages,
  idx,
  canRetryOrEdit,
  editingMessageId,
  onRetry,
  onEditLastMessage,
  makeHtmlParsingOptions,
}) => {
  const isLastUser = !messages.slice(idx + 1).some((m) => m.role === "user");
  const showActions = isLastUser && canRetryOrEdit;

  return (
    <Flex
      flexDirection="column"
      alignItems="flex-end"
      justifyContent="flex-end"
      mt="4px"
      mb="4px"
      gap="4px"
    >
      <Box
        background="surfaceRaised"
        color="bodyText"
        padding="6px 8px"
        borderRadius={2}
        maxWidth="95%"
        border="1px solid"
        borderColor="surfaceBorder"
        boxShadow="0 2px 8px rgba(0,0,0,0.1)"
        style={{ wordWrap: "break-word" }}
      >
        {parseHTMLToReact(message.content, makeHtmlParsingOptions(false))}
      </Box>
      {showActions && (
        <Flex gap="s" alignItems="center">
          <Popover text="Retry" direction="top" width="fit-content">
            <Button
              type="button"
              variant="subtle"
              iconOnly
              small
              height="24px"
              width="24px"
              onClick={onRetry}
              ariaLabel="Retry"
            >
              <Icon icon={["fas", "redo"]} color="subText" />
            </Button>
          </Popover>
          <Popover text="Edit" direction="top" width="fit-content">
            <Button
              type="button"
              variant="subtle"
              iconOnly
              small
              height="24px"
              width="24px"
              onClick={onEditLastMessage}
              ariaLabel="Edit"
              disabled={!!editingMessageId}
            >
              <Icon icon={["fas", "pen"]} color="subText" />
            </Button>
          </Popover>
        </Flex>
      )}
    </Flex>
  );
};

UserMessage.propTypes = {
  message: PropTypes.object.isRequired,
  messages: PropTypes.array.isRequired,
  idx: PropTypes.number.isRequired,
  canRetryOrEdit: PropTypes.bool.isRequired,
  editingMessageId: PropTypes.string,
  onRetry: PropTypes.func.isRequired,
  onEditLastMessage: PropTypes.func.isRequired,
  makeHtmlParsingOptions: PropTypes.func.isRequired,
};
